import { Directive, ElementRef, inject, input, output } from '@angular/core';

@Directive({
    selector: '[qpxClickOutside]',
    host: {
        '(document:click)': 'onClick($event)',
    },
})
export class ClickOutside {
    //#region Dependency injection
    private readonly el = inject<ElementRef<HTMLElement>>(ElementRef);
    //#endregion

    //#region Inputs
    public readonly ignoredSelectors = input<readonly string[]>([]);
    //#endregion

    //#region Outputs
    public readonly clickOutside = output<void>();
    //#endregion

    //#region Template methods
    protected onClick(e: Event): void {
        if (!(e.target instanceof Node)) return;

        const clickedInside = this.el.nativeElement.contains(e.target);
        const clickedIgnoredElement = this.isIgnoredTarget(e.target);
        if (!clickedInside && !clickedIgnoredElement) {
            this.clickOutside.emit();
        }
    }
    //#endregion

    //#region Private methods
    private isIgnoredTarget(target: Node): boolean {
        const targetElement =
            target instanceof Element ? target : target.parentElement;

        return (
            targetElement !== null &&
            this.ignoredSelectors().some(
                (selector) => targetElement.closest(selector) !== null
            )
        );
    }
    //#endregion
}
